import { Component, Input, OnInit, AfterViewInit, AfterViewChecked } from '@angular/core';
import { QuestionBase } from '@app/core/models/question/question-base';
import { FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GaugeChartQuestion } from '@app/core/models/question/gauge-chart-question';

@Component({
    selector: 'gauge-chart',
    template: `
        <div class="gauge-chart-wrapper" [class.not-last-chart]="question.key !== 'healthPreventionAnalysis'" 
            [class.last-chart]="question.key === 'healthPreventionAnalysis'" [formGroup]="form">
            <div class="gauge-chart">
                <img class="bg-gauge" [src]="getSafeBackgroundUrl()"
                    alt="#" />
                <div class="ic-clockwise second" [style.transform]="handlerCompare()"></div>
                <div class="result kyc-f-16 kyc-text-bold">{{ currentValue.toFixed(2) }}</div>
            </div>
            <div class="gauge-chart-label kyc-bg-white pt-1 pb-1">
                <p class="mb-0 kyc-f-21 text-center kyc-text-light">{{question.label}}</p>
            </div>
        </div>

    `
})
export class GaugeChartComponent implements OnInit {

    @Input() question: GaugeChartQuestion;
    @Input() form: FormGroup;

    rotate: number;
    formValues: any;
    currentValue: number;

    constructor(private sanitizer: DomSanitizer) {

    }

    ngOnInit(): void {
        this.formValues = this.form.value;
        this.setRotate();
        this.form.valueChanges.subscribe(values => {
            this.formValues = values;

            this.setRotate();
        });
    }

    getSafeBackgroundUrl(): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.question.icon);
    }

    private setRotate() {
        switch (this.question.key) {
            default:
            case 'lifestyleIndex':
                this.currentValue = (this.formValues.iSmoke + this.formValues.iDrink + 100 - this.formValues.iEatHealthy) / 3;
                this.rotate = this.currentValue / 100 * 180 - 90;
                this.formValues.lifestyleIndex = this.rotate;
                break;
            case 'bodyMassIndex':
                const bodyMassIndex = this.formValues.myWeight / (this.formValues.myHeight / 100 * this.formValues.myHeight / 100);
                this.currentValue = bodyMassIndex;
                if (bodyMassIndex < 18.5) {
                    this.rotate = -75;
                } else {
                    if (bodyMassIndex >= 18.5 && bodyMassIndex < 25) {
                        this.rotate = -45;
                    } else {
                        if (bodyMassIndex >= 25 && bodyMassIndex < 30) {
                            this.rotate = -15;
                        } else {
                            if (bodyMassIndex >= 30 && bodyMassIndex < 35) {
                                this.rotate = 15;
                            } else {
                                if (bodyMassIndex >= 35 && bodyMassIndex < 40) {
                                    this.rotate = 45;
                                } else {
                                    this.rotate = 75;
                                }
                            }
                        }
                    }
                }
                this.formValues.bodyMassIndex = this.rotate;
                break;
            case 'healthPreventionAnalysis':
                this.currentValue = (this.formValues.getSick + this.formValues.medicalCheckUp + this.formValues.familyCriticalIllness +
                    this.formValues.myCriticalIllness + this.formValues.disease + this.formValues.accident) / 6;
                this.rotate = this.currentValue / 100 * 180 - 90;
                this.formValues.healthPreventionAnalysis = this.rotate;
                break;
        }
    }

    handlerCompare() {
        return `rotate(${this.rotate}deg)`;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/gauge-chart/gauge-chart.ts